import React from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowUpRight } from "lucide-react";
import { BrandLogo } from "./BrandLogo";
import { WhatsAppIcon } from "./icons/WhatsAppIcon";

export default function Footer() {
  return (
    <footer
      className="mt-0 relative overflow-hidden"
      style={{ background: "var(--brand-navy)", color: "rgba(255,255,255,0.82)" }}
      data-testid="main-footer"
    >
      <div aria-hidden className="absolute -bottom-40 -left-40 w-[520px] h-[520px] rounded-full opacity-[0.1] blur-3xl" style={{ background: "var(--brand-accent)" }}/>

      <div className="container-x relative py-12 md:py-20">
        <div className="grid md:grid-cols-12 gap-8 md:gap-10 items-start">
          <div className="md:col-span-7">
            <Link to="/" className="inline-block mb-5 md:mb-6">
              <BrandLogo imgClassName="h-12 md:h-16" variant="light" subline="Corredora CMF" iconBg="rgba(255,255,255,0.04)" />
            </Link>
            <p className="text-base md:text-lg leading-relaxed opacity-80 max-w-md" style={{ fontFamily: "Manrope" }}>
              Expertos en seguros de{" "}
              <span className="serif" style={{ color: "var(--brand-accent-light)" }}>comunidades</span>{" "}
              en Chile.
            </p>
          </div>

          <div className="md:col-span-5">
            <div className="text-[10px] uppercase tracking-[0.24em] font-bold opacity-65 mb-5">Contacto</div>
            <ul className="space-y-3.5">
              <li>
                <a href="mailto:Lucas@micomunidadsegura.cl" className="flex items-center gap-3 group transition-all">
                  <div className="w-9 h-9 rounded-lg flex items-center justify-center transition-all group-hover:bg-[var(--brand-accent)]" style={{ background: "rgba(255,255,255,0.06)" }}>
                    <Mail size={15}/>
                  </div>
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.18em] opacity-60 font-bold">Email</div>
                    <div className="text-[14px] font-semibold" style={{ fontFamily: "Manrope" }}>Lucas@micomunidadsegura.cl</div>
                  </div>
                </a>
              </li>
              <li>
                <a href="https://wa.me/56912345678" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 group transition-all">
                  <div className="w-9 h-9 rounded-lg flex items-center justify-center transition-all group-hover:bg-[var(--brand-accent)]" style={{ background: "rgba(255,255,255,0.06)" }}>
                    <WhatsAppIcon size={15}/>
                  </div>
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.18em] opacity-60 font-bold">WhatsApp</div>
                    <div className="text-[14px] font-semibold inline-flex items-center gap-1" style={{ fontFamily: "Manrope" }}>+56 9 4296 4199 <ArrowUpRight size={12}/></div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t flex flex-col md:flex-row justify-between gap-2 text-xs opacity-60" style={{ borderColor: "rgba(255,255,255,0.08)" }}>
          <div>© {new Date().getFullYear()} Mi Comunidad Segura SpA · Regulados por la CMF</div>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <Link to="/carta-asignacion" className="hover:text-white transition" data-testid="footer-carta-asignacion">Carta asignación</Link>
            <span aria-hidden="true">·</span>
            <span>Ley 19.628 · Datos protegidos</span>
            <span aria-hidden="true">·</span>
            <Link to="/admin/login" className="hover:text-white transition" data-testid="footer-admin-login">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
